import { ORDER_MAXIMUM_PRIVATE } from '../constants/constants';

const SELECTOR_FIELD_BROCHURES_ORDERING = '[data-identifier="brochures-ordering"]';
const SELECTOR_HIDDEN_FIELD_BROCHURES_QUANTITY_OVERALL = '[name$="[brochures-ordering]"]';
const SELECTOR_INPUT_FIELD_BROCHURES_QUANTITY = '.kid-form__input--order-quantity';

const updateOverall = (_caller) => {
  const container = _caller.parents(SELECTOR_FIELD_BROCHURES_ORDERING);
  const quantityOverallField = container.find(SELECTOR_HIDDEN_FIELD_BROCHURES_QUANTITY_OVERALL);

  let value = 0;
  container.find(SELECTOR_INPUT_FIELD_BROCHURES_QUANTITY).each(function() {
    value += parseInt($(this).val());
  });

  if (value === 0) {
    //important for (typo3) "NotEmpty" - form validator
    value = '';
  }

  quantityOverallField.val(value);
};

const isPrivate = () => {
  const nodePrivate = document.querySelector('[data-switch-value-0]');
  return nodePrivate && !nodePrivate.classList.contains('d-none');
};

document.addEventListener('DOMContentLoaded', function() {
  $('.kid-form__switch').each(function() {
    $(this)
      .find('[data-action="access"]')
      .on('click', (e) => {
        setTimeout(function() {
          $(SELECTOR_INPUT_FIELD_BROCHURES_QUANTITY).each(function() {
            const ORDER_MAXIMUM = isPrivate()
              ? ORDER_MAXIMUM_PRIVATE
              : parseInt($(this).attr('data-om'));
            const quantityOverallField = $(this);
            const value = quantityOverallField.val();
            quantityOverallField.val(Math.min(value, ORDER_MAXIMUM)); // Enforce max value of ORDER_MAXIMUM
          });
        }, 200); // Timeout: wait until values of switch are set in another JS (form-switch.js)
      });
  });

  $('form')
    .find(SELECTOR_FIELD_BROCHURES_ORDERING)
    .each(function() {
      const quantityOverallField = $(this).find(SELECTOR_HIDDEN_FIELD_BROCHURES_QUANTITY_OVERALL);
      if (quantityOverallField.length !== 1) {
        return false;
      }
      let value = 0;
      $(this)
        .find(SELECTOR_INPUT_FIELD_BROCHURES_QUANTITY)
        .each(function() {
          value += parseInt($(this).val());
        });
      if (value === 0) {
        //important for (typo3) "NotEmpty" - form validator
        value = '';
      }
      quantityOverallField.val(value);
    });

  // Increment
  $('.kid-form__calculator').on('click', '.kid-form__calculator-button.increment', function() {
    let isCampaign = $(this)
      .closest('.kid-form__calculator')
      .hasClass('kid-form__calculator--orderBrochuresCampaign');

    var $input = $(this)
      .closest('.kid-form__calculator')
      .find('input.kid-form__input');
    var value = parseInt($input.val(), 10);
    if (isNaN(value)) {
      value = 0;
    } // Check for NaN
    let order_maximum = isPrivate() ? ORDER_MAXIMUM_PRIVATE : parseInt($input.attr('data-om'));
    let incrementValue = isCampaign ? (order_maximum < 9 ? 1 : 5) : 1;
    //console.log('incrementValue', incrementValue);
    //console.log('orderMaximum', order_maximum);
    let newValue = value + incrementValue;
    if (newValue > order_maximum) {
      newValue = order_maximum;
    }
    $input.val(newValue);

    updateOverall($(this));
  });

  // Decrement
  $('.kid-form__calculator').on('click', '.kid-form__calculator-button.decrement', function() {
    let isCampaign = $(this)
      .closest('.kid-form__calculator')
      .hasClass('kid-form__calculator--orderBrochuresCampaign');

    var $input = $(this)
      .closest('.kid-form__calculator')
      .find('input.kid-form__input');
    var value = parseInt($input.val(), 10);
    if (isNaN(value)) {
      value = 0;
    } // Check for NaN
    let order_maximum = isPrivate() ? ORDER_MAXIMUM_PRIVATE : parseInt($input.attr('data-om'));
    let decrementValue = isCampaign ? (order_maximum < 9 ? 1 : 5) : 1;
    //console.log('decrementValue', decrementValue);
    //console.log('orderMaximum', order_maximum);

    let newValue = value - decrementValue;
    if (newValue < 0) {
      newValue = 0;
    }
    $input.val(newValue);

    updateOverall($(this));
  });

  // Restrict input to numbers only and enforce maximum value
  $('.kid-form__calculator').on('input', '.kid-form__input', function() {
    var value = $(this).val();
    value = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    value = parseInt(value, 10);
    if (isNaN(value)) {
      $(this).val('');
    } else {
      let order_maximum = isPrivate() ? ORDER_MAXIMUM_PRIVATE : parseInt($(this).attr('data-om'));
      $(this).val(Math.min(value, order_maximum)); // Enforce max value of ORDER_MAXIMUM
    }
    updateOverall($(this));
  });
});
